import type { FC } from 'react';
import { Fragment, useEffect } from 'react';
import { MDText } from 'i18n-react';
import { isNull } from 'lodash';

import { MonetaryValue } from 'Components/pages/Wallet/UI/MonetaryValue';
import { applySessionReplayMask } from 'Services/datadog/datadogRum';
import { MASKED_EVENT_VALUES } from 'Services/datadog/datadogRum.const';

import LocalTexts from '../../PurchasesVehicleList.texts';
import { sendPricePopoverEvents } from '../PurchasesVehicleListValueCell.helpers';

import styles from '../PurchasesVehicleListValueCell.module.scss';

const LocalT = new MDText(LocalTexts);

type BiddingSavingsViewProps = {
	maximumBid: number;
	slug: string;
	type: string;
	value: number;
};

export const BiddingSavingsView: FC<BiddingSavingsViewProps> = ({ maximumBid, type, value }) => {
	const { account } = MASKED_EVENT_VALUES;

	const list = [
		{
			title: `${LocalT.translate('priceBreakdownPopover.vehiclePrice')}`,
			value: (
				<MonetaryValue
					{...applySessionReplayMask({ maskedActionName: account.value })}
					value={value}
					variant="regular"
				/>
			),
		},
		{
			title:
				type === 'offer'
					? `${LocalT.translate('priceBreakdownPopover.maxOffer')}`
					: `${LocalT.translate('priceBreakdownPopover.maxBid')}`,
			value: (
				<MonetaryValue
					{...applySessionReplayMask({ maskedActionName: account.maximumBid })}
					value={!isNull(maximumBid) ? maximumBid : value}
					variant="regular"
				/>
			),
		},
		{
			hide: maximumBid <= value || isNull(maximumBid),
			title: `${LocalT.translate('priceBreakdownPopover.savings')}`,
			value: (
				<span className={styles.gainValue}>
					<MonetaryValue
						{...applySessionReplayMask({ maskedActionName: account.savings })}
						value={maximumBid - value}
						variant="regular"
					/>
				</span>
			),
		},
	];

	useEffect(() => {
		sendPricePopoverEvents();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<h5>{LocalT.translate('priceBreakdownPopover.title')}</h5>
			<ul>
				{list
					.filter(({ hide }) => !hide)
					.map((item) => (
						<Fragment key={item.title}>
							<li>
								<span>{item.title}</span>
								{item.value}
							</li>
						</Fragment>
					))}
			</ul>
		</>
	);
};
